module.exports = __webpack_public_path__ + "img/4edb564.png";